module.exports = __webpack_public_path__ + "static/media/step2.b221e17c.svg";